<div class="customer-journey-dashboard">
  <!-- Top Banner -->
  <div class="tab-description">
    Highlights a focused view of repeat customers, their engagement timeline and NPS metrics, also drill into any customer’s full journey.
  </div>

  <!-- User data table -->
  <div >
    <div class="table-header-row">
      <div class="user-data-table-paging">
        <button type="button" [disabled]="!pagingButtons.isFirst || isDataLoading" (click)="paginateUserList('first')" aria-label="First page">
          <img src="assets/images/chevron-double-left.svg" alt="First" />
        </button>
        <button type="button" [disabled]="!pagingButtons.isPrevious || isDataLoading" (click)="paginateUserList('previous')" aria-label="Previous page">
          <img src="assets/images/chevron-left.svg" alt="Previous" />
        </button>
        <span [class.disabled]="pagingDetails.total <= 0">{{ pagingDetails.start }} - {{ pagingDetails.end }} of {{ pagingDetails.total }}</span>
        <button type="button" [disabled]="!pagingButtons.isNext || isDataLoading" (click)="paginateUserList('next')" aria-label="Next page">
          <img src="assets/images/chevron-right.svg" alt="Next" />
        </button>
        <button type="button" [disabled]="!pagingButtons.isLast || isDataLoading" (click)="paginateUserList('last')" aria-label="Last page">
          <img src="assets/images/chevron-double-right.svg" alt="Last" />
        </button>
      </div>
    </div>
    <div class="card-loader" *ngIf="isDataLoading">
      <app-ltms-loader></app-ltms-loader>
    </div>
    <div class="card-error-message" *ngIf="customers.length === 0 && !isDataLoading">
      <div class="no-data-text">No data available</div>
    </div>
    <div class="table-responsive" *ngIf="customers.length > 0 && !isDataLoading">
      <table class="user-data-table">
        <thead>
          <tr>
            <th>User ID</th>
            <th>First interaction date</th>
            <th>Last interaction date</th>
            <th>Total responses</th>
            <th>Promoter</th>
            <th>Passives</th>
            <th>Detractor</th>
            <th>NPS</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let customer of customers" [class.selected]="selectedCustomerId === customer.id">
            <td class="user-id-cell" (click)="openCustomerJourney(customer)">
              <img src="assets/images/launch.svg" alt="launch" class="launch-icon">
              {{customer.id}}
            </td>
            <td>{{customer.firstInteraction}}</td>
            <td>{{customer.lastInteraction}}</td>
            <td>{{customer.total_responses}}</td>
            <td>{{customer.promoter}}</td>
            <td>{{customer.passive}}</td>
            <td>{{customer.detractor}}</td>
            <td>{{customer.nps}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div> 

<ng-container *ngIf="selectedCustomer">
  <app-customer-journey-view class="side-panel" [customerDetail]="selectedCustomer"
    (closePanel)="closeCustomerJourney()"></app-customer-journey-view>
</ng-container>